export class SearchErpCustomerRequest {
    public customerName : string;
}